import { render } from "./CheckboxGroup.vue?vue&type=template&id=58afde5b&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"

import "./CheckboxGroup.vue?vue&type=style&index=0&id=58afde5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58afde5b"]])

export default __exports__